import { useEffect, useState, Suspense } from 'react'
import { useSelector } from 'react-redux'
import { PositionalAudio } from '@react-three/drei'

export default function MeshSound({ index, position }) {
  const { hasStarted, currentIndex } = useSelector((state) => state.progress)

  const [isSoundActive, setIsSoundActive] = useState(false)

  useEffect(() => {
    if (hasStarted && currentIndex === index) {
      setIsSoundActive(true)
    }
  }, [hasStarted, currentIndex])

  return (
    <>
      {hasStarted && isSoundActive && currentIndex == index && (
        <group position={position ? position : undefined}>
          <Suspense>
            <PositionalAudio
              url={`/sounds/${index}.mp3`}
              distance={1}
              loop
              autoplay
            />
          </Suspense>
          {/* <mesh>
            <boxGeometry args={[1, 1, 1]} />
            <meshBasicMaterial color="red" />
          </mesh> */}
        </group>
      )}
    </>
  )
}
